import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { SlugService } from '@core/services/slug.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { LoginResolver } from './services/login.resolver';
var LoginComponent = /** @class */ (function () {
    function LoginComponent(router, slugService, loginResolver, activatedRoute, fuseTranslationLoaderService) {
        this.router = router;
        this.slugService = slugService;
        this.loginResolver = loginResolver;
        this.activatedRoute = activatedRoute;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.loginCustomization = null;
        this.subscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.data
            .pipe(takeUntil(this.subscriptions))
            .subscribe(function (data) {
            var hasLoginCustomization = !!data.loginCustomization;
            var isFieldControlAppBr = _this.slugService.isFieldControlAppBr();
            if (isFieldControlAppBr && !hasLoginCustomization) {
                return _this.router.navigateByUrl('/404');
            }
            _this.loginCustomization = data.loginCustomization || null;
        });
        this.router.events
            .pipe(takeUntil(this.subscriptions))
            .pipe(filter(function (e) { return e instanceof NavigationCancel || e instanceof NavigationEnd; }))
            .pipe(map(function () { return _this.activatedRoute; }))
            .subscribe(function () {
            if (_this.router.url.includes('login')) {
                _this.loginResolver.hideToolbarAndNavbar();
            }
        });
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    return LoginComponent;
}());
export { LoginComponent };
